import React from 'react';
import { Minus, Plus } from 'lucide-react';
import { FaCheck } from 'react-icons/fa6';
import UseProductDetailsPage from './UseProductDetailsPage';
import RatingStars from './Components/ProductRatingStars';
import ProductAccordion from './Components/ProductAccordion';
import ProductAddToCart from './Components/ProductAddToCart';
import RelatedItems from './Components/RelatedItems';
import { Link } from 'react-router-dom';
import config from '../../../../config/environment';
import BreadcrumbComponents from './Components/BreadcrumbComponents';
import ProductThumbnailsComponents from './Components/ProductThumbnailsComponents';
import ProductShareComponents from './Components/ProductShareComponents';
import ProductDetailsPageHelmet from '../../../HelmetComponents/ProductDetailsPageHelmet';
const SERVER_URL = config.SERVER_URL;
const ProductDetailsPage: React.FC = () => {
  const {
    thumbnails,
    thumbIndex,
    states,
    setThumbIndex,
    setScrollDirection,
    setIsManualSelect,
    setMainImage,
    mainImage,
    setQuantity,
    quantity,
    setIsCartOpen,
    isCartOpen,
    cartItems,
    openIsCartPopup,
    cartDataArr,
    cartItemPlusMinus,
    shareProduct,
    goToProductDetailsPage,
    couponObj,
    navigate,
    customerId,
  } = UseProductDetailsPage();

  return (
    <>
      <ProductDetailsPageHelmet />
      <div>
        {/* Breadcrumb */}
        <BreadcrumbComponents productInfo={states.productInfo} navigate={navigate} />
        <div className='flex flex-col lg:flex-row lg:px-1 md:p-10 mx-[0%] sm:mx-[0%] md:mx-[0%] lg:mx-[16%] bg-white rounded-xl gap-2'>
          {/* Images Thumbnails */}
          <ProductThumbnailsComponents
            thumbnails={thumbnails}
            thumbIndex={thumbIndex}
            setThumbIndex={setThumbIndex}
            setScrollDirection={setScrollDirection}
            setIsManualSelect={setIsManualSelect}
            mainImage={mainImage}
            setMainImage={setMainImage}
            SERVER_URL={SERVER_URL}
          />
          {/* Product Details content */}
          <div className=' flex flex-col space-y-6 px-4 sm:px-4 md:px-3 lg:px-2'>
            <div className='flex flex-col space-y-2 sm:space-y-2 md:space-y-4 lg:space-y-4'>
              <div className='flex flex-col space-y-2'>
                {/* Title */}
                <h1 className='font-semibold text-xl sm:text-xl md:text-2xl text-black font-poppins'>
                  {states.productInfo.item_name}
                </h1>
                {/* Stock */}
                <div className='flex items-center gap-2 font-poppins'>
                  <p className='text-base sm:text-base md:text-lg lg:text-lg font-poppins'>
                    Pack of{' '}
                    {states.productInfo.uom_conversion
                      ? states.productInfo.uom_conversion?.find((u: any) => u.uom === 'Nos')?.conversion_factor
                      : '--'}{' '}
                  </p>
                  <p className='bg-green-100 text-green-700 px-2 py-1 rounded text-xs sm:text-sm font-poppins'>
                    In Stock
                  </p>
                </div>
                {/* Reviews */}
                {/* <RatingStars
                  rating={states.productInfo.average_rating || 0}
                  showLabel
                  labelText={states.productInfo.total_reviews}
                /> */}
                {/* Highlights */}
                {states.productPointDesc.current && states.productPointDesc.current.length > 0 && (
                  <ul className='text-sm sm:text-sm md:text-base space-y-2 mb-4 list-disc list-inside'>
                    {states.productPointDesc.current.map((point: any, i: number) => (
                      <li key={`point-${i}-${point.substring(0, 20)}`} className='flex items-center gap-2'>
                        <FaCheck className='w-5 h-5 rounded-full fill-white bg-orange-950 p-1' />
                        <span className='font-poppins'>{point}</span>
                      </li>
                    ))}
                  </ul>
                )}

                {customerId && customerId.current && customerId.current !== '' && (
                  <>
                    {/* Price */}
                    <div className='flex items-center flex-wrap gap-3 pt-5 sm:pt-5 md:pt-5 lg:pt-2'>
                      <span className='text-xl sm:text-2xl font-bold text-black font-poppins'>
                        ₹
                        {states.productInfo?.custom_websiteapp_price
                          ? states.productInfo?.custom_websiteapp_price.toFixed(2)
                          : '00.00'}
                      </span>
                      <span className='line-through text-gray-500 text-base sm:text-lg font-poppins'>
                        {states.productInfo?.price?.formatted_mrp
                          ? `₹${states.productInfo.price.formatted_mrp ? Number(states.productInfo.price.formatted_mrp).toFixed(2) : '00:00'}`
                          : null}
                      </span>
                      <span className='bg-red-100 text-red-700 px-2 py-1 rounded-full text-xs sm:text-sm font-poppins'>
                        {states.productInfo?.price?.discount_label ?? ''}
                      </span>
                      <span className='text-gray-500 sm:text-lg  text-base font-poppins'>inc. all taxes</span>
                    </div>

                    {/* Quantity + Add to Cart */}
                    <div className='flex justify-center items-center gap-4 border rounded-lg p-3 sm:w-full max-w-lg'>
                      {/* Quantity */}
                      {/* <div className="flex items-center h-[45px] border border-[#C12E2A] rounded-lg ">
                                                <button
                                                    className="w-10 h-full flex items-center justify-center"
                                                    onClick={() => setQuantity(Math.max(1, quantity - 1))}
                                                >
                                                    <Minus size={16} className="text-red-600" />
                                                </button>
                                                <span className="px-4 text-base font-medium">{quantity}</span>
                                                <button
                                                    className="w-10 h-full flex items-center justify-center"
                                                    onClick={() => setQuantity(quantity + 1)}
                                                >
                                                    <Plus size={16} className="text-red-600" />
                                                </button>
                                            </div>

                                            <button
                                                className="w-[200px] sm:w-[260px] md:w-[300px] h-[50px] rounded-[10px] bg-[#C12E2A] shadow hover:bg-red-900 flex items-center justify-center"
                                                onClick={() => openIsCartPopup(states.productInfo.item_code)}
                                            >
                                                <span className="text-white font-poppins font-medium text-[16px] sm:text-[18px] font-poppins">
                                                    Add to Cart
                                                </span>
                                            </button> */}

                      <div className='flex items-center border border-[#C12E2A] rounded-lg '>
                        <button
                          className={`w-10 flex items-center justify-center py-2.5 ${states.itemCartExistingQty.current > 0 ? 'opacity-50 cursor-not-allowed' : ''}`}
                          onClick={() => setQuantity(Math.max(1, quantity - 1))}
                          disabled={states.itemCartExistingQty.current > 0}
                        >
                          <Minus size={16} className='text-red-600' />
                        </button>

                        <span className='px-4 text-base font-medium'>{quantity}</span>
                        <button
                          className={`w-10 flex items-center justify-center py-2.5 ${states.itemCartExistingQty.current > 0 ? 'opacity-50 cursor-not-allowed' : ''}`}
                          onClick={() => setQuantity(quantity + 1)}
                          disabled={states.itemCartExistingQty.current > 0}
                        >
                          <Plus size={16} className='text-red-600' />
                        </button>
                      </div>
                      {states.itemCartExistingQty.current > 0 ? (
                        <Link to='/product/cart'>
                          <button className='py-2 w-[200px] sm:w-[260px] md:w-[300px] rounded-[10px] bg-[#15803d] shadow hover:bg-green-900 flex items-center justify-center'>
                            <span className='text-white font-medium text-sm sm:text-sm md:text-base lg:text-base font-poppins'>
                              Go to Cart
                            </span>
                          </button>
                        </Link>
                      ) : (
                        <button
                          className='py-2 w-[200px] sm:w-[260px] md:w-[300px] rounded-[10px] bg-[#C12E2A] shadow hover:bg-red-900 flex items-center justify-center'
                          onClick={() => {
                            openIsCartPopup(states.productInfo.item_code);
                          }}
                        >
                          <span className='text-white font-medium text-sm sm:text-sm md:text-base lg:text-base font-poppins'>
                            Add to Cart
                          </span>
                        </button>
                      )}
                    </div>
                  </>
                )}
              </div>

              {/* Share Product*/}
              <ProductShareComponents shareProduct={shareProduct} item_code={states.productInfo.item_code} />

              {/* -------- Accordion -------- */}
              <div className='flex gap-4 w-fitflex flex-col sm:gap-6 min-h-fit max-w-lg md:w-auto font-poppins'>
                <ProductAccordion items={states.accordionItems.current} />
              </div>
            </div>
          </div>
          <ProductAddToCart
            isCartOpen={isCartOpen}
            setIsCartOpen={setIsCartOpen}
            cartItems={cartItems}
            cartDataArr={cartDataArr}
            cartItemPlusMinus={cartItemPlusMinus}
            couponObj={couponObj}
          />
        </div>

        {states.relatedItems.current && states.relatedItems.current.length > 0 && (
          <div className='border-t border-[#E2C06C] mb-4 mt-2 sm:mt-2 md:mt-0 lg:mt-0'>
            <RelatedItems
              relatedItems={states.relatedItems.current}
              goToProductDetailsPage={goToProductDetailsPage}
              customerId={customerId}
            />
          </div>
        )}
      </div>
    </>
  );
};
export default ProductDetailsPage;
